import { Side } from '@ebalance/proto/bfftypes/v1/side_pb'
import type { TFunction } from 'i18next'

/**
 * 売買 (Side) → 表示文言 (買 / 売)。 BUY 以外 (= SELL / UNSPECIFIED) は売を返す。
 */
export const sideLabel = (t: TFunction, side: Side): string =>
  side === Side.BUY
    ? t('page:biddingSpot.side.buy')
    : t('page:biddingSpot.side.sell')
